import { useEffect, useState } from "react";
import useToken from "../../auth/useToken";
import { usersService } from "../../../services/administration/usersService";


interface Props {
  userId: string;
}

export default function useCountryHistory({ userId }: Props) {
  const [countryHistory, setCountryHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const { token } = useToken();

  const getCountryHistory = async () => {
    if (!token || !userId) return;

    try {
      setLoading(true);

      const { data } = await usersService.getCountryHistory(userId, token);
      if (data.history) {
        setCountryHistory(data.history);
      } else {
        setCountryHistory([]);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountryHistory();
  }, [token, userId]);

  return {
    countryHistory,
    loading,
    error,
    refetch: getCountryHistory,
  };
}
